export const environment = {
  production: false,
  maintenance: false,
  apiUrl: 'https://dev-ai.docketscope.com/api/'
};